/**
 * A2: the app's first moments. In the iPad app the native shell is set up
 * (native/install.ts) before anything renders: AccessProvider reads the device
 * store in an effect after the first render, and the screens ask for the PDF
 * opener while rendering, so none of them can meet a shell half set up.
 *
 * A set-up that fails still renders. The store then stays unavailable, which
 * the start-up shows as a problem with a retry, never as "not enrolled".
 */
export async function start(options: {
  /** The native shell's set-up; null in a browser and in every other build. */
  install: (() => Promise<void>) | null
  render: () => void
}): Promise<void> {
  if (options.install) {
    try {
      await options.install()
    } catch {
      // Nothing to log here (no personal data, and nowhere to send it).
    }
  }
  options.render()
}
